/* eslint-disable react/no-array-index-key */
import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'wouter';

import { useUser } from '../../contexts/UserContext';
import StyledButton from '../buttons/StyledButton';
import Menu from './Menu';

import styles from '../../../styles/menus/mobile.module.css';

const propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({ url: PropTypes.string })),
    open: PropTypes.bool,
    onClickItem: PropTypes.func,
    proUrl: PropTypes.string,
    catalogUrl: PropTypes.string,
    className: PropTypes.string,
    // itemsClassName: PropTypes.string,
    // itemClassName: PropTypes.string,
    // activeItemClassName: PropTypes.string,
};

function Mobile({
    items = [],
    open = false,
    onClickItem = null,
    proUrl = null,
    catalogUrl = null,
    className = null,
    // itemsClassName = null,
    // itemClassName = null,
    // activeItemClassName = null,
}) {
    const route = useUrlGenerator();
    const user = useUser();

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.open]: open,
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                <Menu
                    className={styles.menu}
                    itemClassName={styles.menuItem}
                    items={items}
                    onClickItem={onClickItem}
                />
                <div className={styles.section}>
                    {user === null ? (
                        <Link
                            className={styles.textLink}
                            href={route('login')}
                            onClick={onClickItem}
                        >
                            <FormattedMessage defaultMessage="Login" description="Button label" />
                        </Link>
                    ) : (
                        <Link
                            className={styles.textLink}
                            href={route('pro.account')}
                            onClick={onClickItem}
                        >
                            <FormattedMessage
                                defaultMessage="My account"
                                description="Button label"
                            />
                        </Link>
                    )}
                    {catalogUrl !== null ? (
                        <StyledButton
                            className={styles.catalogButton}
                            href={catalogUrl}
                            size="small"
                            external
                            target="_blank"
                        >
                            <FormattedMessage defaultMessage="Catalog" description="Menu label" />
                        </StyledButton>
                    ) : null}
                    <StyledButton
                        className={styles.button}
                        href={user === null ? proUrl : route('pro.home')}
                        size="small"
                        onClick={onClickItem}
                    >
                        <FormattedMessage defaultMessage="Pro corner" description="Button label" />
                    </StyledButton>
                </div>
            </div>
        </div>
    );
}

Mobile.propTypes = propTypes;

export default Mobile;
